import { CountsReturnType } from '@monoimin/sb-types';

import { getUrlOrigin } from '../helpers/getUrlOrigin';

export async function fetchArticleStats(
  full_slug: string
): Promise<CountsReturnType> {
  const origin = getUrlOrigin();

  const url = `${origin}/api/article-stats/${full_slug}`;

  const res = await fetch(url, {
    next: {
      revalidate: 86_400, // 24h
      tags: [`article-stats-${full_slug}`],
    },
  } as NextFetchRequestConfig)
    .then((res) => (res.ok ? res.json() : null))
    .then((res) => res as CountsReturnType | null)
    .catch(() => {
      return null;
    });

  return (
    res || {
      wordsCount: 0,
      lettersCount: 0,
      lettersCountWithoutSpaces: 0,
      readingTime: 0,
    }
  );
}
